import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { navLinks } from "./NavLinks";

const Sidebar = ({ children, sidebar, setSidebar }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [subMenuOpen, setSubMenuOpen] = useState(false);
    const { pathname } = useLocation();

    const handleSubMenu = () => setSubMenuOpen(!subMenuOpen);
    const handleCloseSidebar = () => setSidebar(false);

    return (
        <div className="">
            <div className=" w-full flex h-[calc(100vh_-_124px)] md:h-[calc(100vh_-_88px)] fill-available overflow-hidden">
                <div
                    onClick={() => setSidebar(false)}
                    className={`${
                        !sidebar && "hidden"
                    } duration-300 ease-linear lg:hidden fixed top-0 right-0 left-0 bottom-0 z-[59] bg-black-70`}
                ></div>
                {/* Sidebar  */}
                <div
                    className={`${
                        sidebar
                            ? "-translate-x-0 duration-300 lg:duration-[0ms] ease-in"
                            : "-translate-x-full duration-300 lg:duration-[0ms] ease-out"
                    } fixed lg:-translate-x-0 left-0 lg:h-[calc(100vh_-_88px)]  overflow-hidden top-0 bottom-0 lg:bottom-auto lg:top-[88px] bg-white z-[60] lg:z-30`}
                >
                    <aside
                        className={`${
                            sidebarOpen ? "w-[263px]" : "w-[263px] lg:w-16 "
                        } h-full flex flex-col justify-between bg-white shrink-0 pb-4 rounded-br lg:duration-300 ease-in relative max-h-full overflow-y-scroll no-scrollbar  overflow-hidden`}
                    >
                        <div
                            className={`${
                                sidebarOpen
                                    ? "justify-end pr-1"
                                    : "justify-center"
                            } duration-300 ease-linear flex w-full sm: items-center absolute top-1 right-2 left-0`}
                        >
                            <button
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                                className="p-1 border hidden lg:block  overflow-visible border-orange-color rounded-full w-fit bg-white cursor-pointer"
                            >
                                <IoIosArrowDown
                                    className={`${
                                        !sidebarOpen
                                            ? "-rotate-90"
                                            : "rotate-90"
                                    } text-orange-color `}
                                />
                            </button>
                        </div>
                        <ul
                            className={`${sidebarOpen ? "px-4" : "px-2"} mt-10`}
                        >
                            {navLinks.slice(0, 5).map((menu) => {
                                const { subMenu } = menu;
                                return (
                                    <li
                                        onClick={
                                            menu.title !== "subscription" &&
                                            handleCloseSidebar
                                        }
                                        key={menu.id}
                                        className=""
                                    >
                                        <NavLink
                                            to={menu.path}
                                            onClick={
                                                menu?.subMenu && handleSubMenu
                                            }
                                            className={`${
                                                sidebarOpen
                                                    ? "hover:text-black"
                                                    : "hover:text-purple-color"
                                            } ${
                                                menu.role === "myStore"
                                                    ? " mb-[17px]"
                                                    : "mb-1"
                                            } ${
                                                menu.title.toLowerCase() !==
                                                    "subscription" &&
                                                "navigation"
                                            } flex items-center justify-between  w-full bg-white rounded-[10px] cursor-pointer hover:bg-[#7900F80F] text-black-80 p-2 `}
                                        >
                                            <div className="flex items-center">
                                                <span
                                                    className={`${
                                                        sidebarOpen && "mr-4"
                                                    } ${
                                                        menu.title.toLowerCase() !==
                                                            "subscription" &&
                                                        "sidebar-icon"
                                                    } mr-4 text-xl p-1.5 w-fit rounded-md bg-black/5 text-black/50 hover:bg-[#7900F80D] hover:text-purple-color inline-block `}
                                                >
                                                    {menu.icon}
                                                </span>
                                                <span
                                                    className={`${
                                                        !sidebarOpen &&
                                                        " lg:hidden"
                                                    } text-sm capitalize font-medium whitespace-nowrap`}
                                                >
                                                    {menu.title}
                                                </span>
                                            </div>
                                            <span
                                                className={`${
                                                    !sidebarOpen && "lg:hidden"
                                                } ${
                                                    subMenuOpen
                                                        ? "-rotate-0"
                                                        : "-rotate-180"
                                                } duration-300 ease-in-out`}
                                            >
                                                {menu.dropdownArrow &&
                                                    menu.dropdownArrow}
                                            </span>
                                        </NavLink>

                                        {/* Sub Menu  */}
                                        <div
                                            className={`${
                                                menu.title.toLowerCase() ===
                                                    "subscription" &&
                                                "border-b border-black-10"
                                            } overflow-hidden `}
                                        >
                                            <ul
                                                className={`${
                                                    menu.title.toLowerCase() ===
                                                        "subscription" &&
                                                    "duration-300 ease-linear"
                                                } ${
                                                    menu?.subMenu && subMenuOpen
                                                        ? "h-28 duration-300 ease-in"
                                                        : "h-0 duration-300 ease-out"
                                                }`}
                                            >
                                                {subMenu?.map((subMenu) => (
                                                    <li
                                                        key={subMenu.id}
                                                        onClick={
                                                            handleCloseSidebar
                                                        }
                                                        className={`${
                                                            subMenu?.subTitle.toLowerCase() ===
                                                                "my subscriptions" &&
                                                            "mt-2"
                                                        } `}
                                                    >
                                                        <NavLink
                                                            to={subMenu.subPath}
                                                            className={`${
                                                                sidebarOpen
                                                                    ? "hover:text-black"
                                                                    : "hover:text-purple-color"
                                                            } mb-1 flex items-center  w-full bg-white rounded-[10px] cursor-pointer hover:bg-[#7900F80F] text-black-80 p-2 navigation`}
                                                        >
                                                            <span
                                                                className={`${
                                                                    sidebarOpen &&
                                                                    "mr-4"
                                                                } mr-4 text-xl p-1.5 w-fit rounded-md bg-black/5 text-black/50 hover:bg-[#7900F80D] hover:text-purple-color inline-block sidebar-icon`}
                                                            >
                                                                {
                                                                    subMenu.subIcon
                                                                }
                                                            </span>
                                                            <span
                                                                className={`${
                                                                    !sidebarOpen &&
                                                                    " lg:hidden"
                                                                } text-sm capitalize font-medium whitespace-nowrap`}
                                                            >
                                                                {
                                                                    subMenu.subTitle
                                                                }
                                                            </span>
                                                        </NavLink>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                        <ul className={`max-w-[236px] hidden md:block`}>
                            {navLinks.slice(5, 7).map((menu) => {
                                return (
                                    <li
                                        onClick={() => setSidebar(false)}
                                        key={menu.id}
                                        className=""
                                    >
                                        <Link
                                            to={menu.path}
                                            className={`${
                                                menu.role === "record"
                                                    ? "bg-purple-color"
                                                    : "bg-orange-color"
                                            } ${
                                                sidebarOpen
                                                    ? "pl-[21px]"
                                                    : "pl-3"
                                            } overflow-hidden flex items-center w-full mb-1 rounded-tr-[30px] rounded-br-[30px] bg-orange-color cursor-pointer text-white p-2`}
                                        >
                                            <span
                                                className={`${
                                                    sidebarOpen && "mr-4"
                                                } text-xl p-1.5 w-fit rounded-md block`}
                                            >
                                                {menu.icon}
                                            </span>
                                            <span
                                                className={`${
                                                    !sidebarOpen && "lg:hidden"
                                                } text-sm capitalize font-medium whitespace-nowrap`}
                                            >
                                                {menu.title}
                                            </span>
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </aside>
                </div>

                {/* Main Content  */}
                <main
                    className={`${
                        sidebarOpen ? "lg:ml-[263px]" : "lg:ml-16"
                    } lg:duration-300 ease-linear  w-full flex-1 max-h-full overflow-hidden overflow-y-scroll`}
                >
                    {children}
                </main>
            </div>

            {/* Home Stream and Video icon for mobile  */}
            <div
                className={`${
                    pathname.includes("chat") || pathname.includes("emails") || pathname.endsWith("/livestream")
                        ? "hidden"
                        : ""
                } md:hidden`}
            >
                <ul className="fixed right-3.5 bottom-[70px] z-40 flex items-center space-x-2">
                    {navLinks.slice(7, 9).map((icon, i) => (
                        <li
                            key={i}
                            className={`${
                                icon.role === "record"
                                    ? "bg-purple-color"
                                    : "bg-orange-color"
                            } text-white rounded-full w-12 h-12 flex items-center justify-center`}
                        >
                            <Link to={icon.path}>{icon.icon}</Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Sidebar;
